import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import { SidebarPortal } from '@plone/volto/components';
import Schema from './schema';
import VideosView from './View';
import { buscarTitulo, codigoDoVideo } from './youtube';

/** Põe o título do YouTube nos vídeos que ainda não têm; diz quais endereços
 *  não são do YouTube. `buscar` é o fetch (trocado nos testes). */
export const completarTitulos = async (videos, buscar) => {
  let mudou = false;
  const invalidos = [];
  const novos = await Promise.all(
    (videos || []).map(async (v) => {
      if (!v || !(v.url || '').trim()) return v;
      const codigo = codigoDoVideo(v.url);
      if (!codigo) {
        invalidos.push(v.url);
        return v;
      }
      if ((v.titulo || '').trim() || !buscar) return v;
      try {
        const titulo = await buscarTitulo(codigo, buscar);
        if (!titulo) return v;
        mudou = true;
        return { ...v, titulo };
      } catch (e) {
        return v;
      }
    }),
  );
  return { videos: novos, mudou, invalidos };
};

/** Edit da Lista de vídeos: o desenho do View e os campos na barra lateral. */
const VideosEdit = ({ data, onChangeBlock, block, selected }) => {
  const schema = Schema();
  const [invalidos, setInvalidos] = useState([]);
  const pendentes = (data.videos || [])
    .filter((v) => v && (v.url || '').trim() && !(v.titulo || '').trim())
    .map((v) => v.url)
    .join('|');

  useEffect(() => {
    let vivo = true;
    const buscar = typeof fetch === 'undefined' ? null : fetch;
    completarTitulos(data.videos, buscar).then((r) => {
      if (!vivo) return;
      setInvalidos(r.invalidos);
      if (r.mudou) onChangeBlock(block, { ...data, videos: r.videos });
    });
    return () => {
      vivo = false;
    };
  }, [pendentes]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <VideosView
        data={data}
        vazio={
          <p className="ag-videos__vazio">
            Lista de vídeos: cole os endereços do YouTube na barra lateral.
          </p>
        }
      />
      {selected && invalidos.length > 0 && (
        <p className="ag-videos__aviso" role="status">
          Endereço que não é de vídeo do YouTube: {invalidos.join(', ')}
        </p>
      )}
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id, value) =>
            onChangeBlock(block, { ...data, [id]: value })
          }
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

VideosEdit.propTypes = {
  data: PropTypes.object.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
  block: PropTypes.string.isRequired,
  selected: PropTypes.bool,
};

export default VideosEdit;
